import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { getGallery, listMedia } from "@/lib/api";
import GalleryView from "@/components/previews/GalleryView";

/** Preview-mode gallery page (authed). Public iframe embed lives at /api/embed/gallery/:id. */
export default function EmbedGallery() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [mediaMap, setMediaMap] = useState({});
  const [err, setErr] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let c = false;
    Promise.all([getGallery(id), listMedia()])
      .then(([g, m]) => {
        if (c) return;
        setData(g);
        const map = {};
        for (const it of (m.media || [])) map[it.id] = { ...it, url: `${process.env.REACT_APP_BACKEND_URL}/api/media/${it.id}.${it.ext}` };
        setMediaMap(map);
      })
      .catch(() => !c && setErr(true))
      .finally(() => !c && setLoading(false));
    return () => { c = true; };
  }, [id]);

  return (
    <div className="min-h-screen bg-white" data-testid="embed-gallery-page">
      <div className="max-w-4xl mx-auto px-6 py-10">
        {loading ? (
          <div className="grid place-items-center h-64 text-zinc-400">
            <Loader2 className="h-5 w-5 animate-spin" />
          </div>
        ) : err || !data ? (
          <div className="text-center text-zinc-500 text-sm mt-20">Gallery not found.</div>
        ) : (
          <GalleryView data={data} mediaMap={mediaMap} />
        )}
      </div>
    </div>
  );
}
